import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import type { AssignOwnerInput, ManagedKpi } from "../api/types.js";
import { kpiKeys } from "./kpiQueryKeys.js";

export interface AssignKpiOwnerVars {
  readonly kpiId: string;
  readonly input: AssignOwnerInput;
}

/**
 * Assign / reassign a KPI's Owner (`PATCH /v1/kpis/:id/owner`). Refreshes the
 * lists (owner shows in the row) and the KPI's detail (an owner is a precondition
 * for activation).
 */
export function useAssignKpiOwner() {
  const config = useApiClient();
  const qc = useQueryClient();
  return useMutation<ManagedKpi, Error, AssignKpiOwnerVars>({
    mutationFn: ({ kpiId, input }) => kpiApi.assignOwner(config, kpiId, input),
    onSuccess: (_data, { kpiId }) => {
      void qc.invalidateQueries({ queryKey: kpiKeys.lists() });
      void qc.invalidateQueries({ queryKey: kpiKeys.detail(kpiId) });
      void qc.invalidateQueries({ queryKey: ["hoshin", "x-matrix"] });
    },
  });
}
